import React, { useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import { FormattedMessage, injectIntl } from "react-intl"
import { Redirect } from "react-router-dom"
import ListingWrapper from "../../common/listing/ListingWrapper"
import PaymentAccount from "../../payment-account/model/paymentaccount"
import PaymentAccountLocationEditModal from "../modals/PaymentAccountLocationEditModal"
import { useGetLocations } from "../useGetLocations"
import { useGetPaymentAccounts } from "../usePaymentAccountSession"
import { generateHeaders, generateRows } from "./PaymentAccountListingHelper"

type OwnProps = {
    paymentAccounts: PaymentAccount[]
}

const PaymentAccountListing = (props: OwnProps) => {

    const [showEditLocationsModal, setShowEditLocationsModal] = useState<boolean>(false)
    const [currentLocationIds, setCurrentLocationIds] = useState<string[]>([])
    const [paymentAccountMerchantId, setPaymentAccountMerchantId] = useState<string>("")

    const { paymentAccounts, isLoading: isLoadingPaymentAccounts, refetch } = useGetPaymentAccounts()
    const {locations, isLoadingLocations, availableLocations} = useGetLocations(paymentAccounts)

    const headers = {
        data: generateHeaders(),
        classNames: [],
    }

    const rows = props.paymentAccounts?.map(paymentAcc => {
        return {
            rowId: paymentAcc.getId(),
            data: generateRows(
                paymentAcc,
                locations,
                setShowEditLocationsModal,
                setCurrentLocationIds,
                setPaymentAccountMerchantId,)
        }
    })

    const handleModalClose = (success: boolean) => {
        setShowEditLocationsModal(false)
        if (success) {
            refetch()
        }
    }

    const standardList = {
        className: "row pt-3",
        headers: headers,
        rows: rows,
        pageSize: 1,
        totalItemsCount: props.paymentAccounts?.length ?? 0,
        showSelectionSize: false,
    }
    const handleAddPaymentAccount = () => {
        setRedirect(<Redirect to={"/payment-processing/new-payment-account"} />)
    }

    const [redirect, setRedirect] = useState<JSX.Element>()

    return <>
        <Container className="p-0" fluid>
            <Row>
                <Col md={4}>
                    <h2 className="m-0 custom-lead">
                        <FormattedMessage
                            id="payment_account_listing.payment_accounts.title"
                            defaultMessage="Payment Accounts"
                        />
                    </h2>
                </Col>
                <Col md={{span: 2, offset: 6}}>
                    <Button
                        onClick={handleAddPaymentAccount}
                        className="btn btn-primary col-12"
                    >
                        <FormattedMessage
                            id= "payment_processing.payment_account_listing.add_new_payment_account"
                            defaultMessage= "Add new payment account" />
                    </Button>
                </Col>
            </Row>
        </Container>
        {redirect}
        <PaymentAccountLocationEditModal
            show={showEditLocationsModal}
            locations={locations}
            isLoading={isLoadingLocations && isLoadingPaymentAccounts}
            paymentAccounts={paymentAccounts}
            availableLocations={availableLocations}
            currentLocationIds={currentLocationIds}
            paymentAccountMerchantId={paymentAccountMerchantId}
            onClose={(e: boolean) => handleModalClose(e)}
        />
        <div className="col-12 ui-module mt-3">
            <ListingWrapper
                standardListProps={standardList}
                isLoading={isLoadingLocations}
            />
        </div>
    </>
}
export default injectIntl(PaymentAccountListing)


// WEBPACK FOOTER //
// ./src/payment-processing/payment-account-listing/PaymentAccountListing.tsx